<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <!-- <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-shop text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Dashboard', path: '/dashboard' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Alternative', path: '/alternative' }"
          ></sidebar-item>
        </sidebar-item> -->

        <sidebar-item
          :link="{
            name: menu_corporate,
            icon: 'fa fa-users text-dtac',
            path: '/portal/corporate'
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_package,
            path: '/portal/package',
            icon: 'ni ni-ungroup text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_pilot_number,
            path: '/portal/pilotnumber',
            icon: 'fa fa-phone-square text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_agent_number,
            path: '/portal/number',
            icon: 'fa fa-mobile text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_user,
            path: '/portal/users',
            icon: 'fa fa-user text-dtac'
          }"
        />

        <sidebar-item
          v-if="isCorporateAdmin"
          :link="{
            name: menu_mlhg,
            path: '/portal/mlhg',
            icon: 'ni ni-ungroup text-dtac'
          }"
        />
        <sidebar-item
          v-if="isCorporateAdminMenu"
          :link="{
            name: menu_pilot_number,
            path: '/portal/pilotnumber',
            icon: 'fa fa-phone-square text-dtac'
          }"
        />
        <sidebar-item
          v-if="isCorporateAdminMenu"
          :link="{
            name: menu_agent_number,
            path: '/portal/number',
            icon: 'fa fa-mobile text-dtac'
          }"
        />
        <!-- <sidebar-item  :link="{ name: menu_voicemail, path: '/portal/voicemail',icon: 'fa fa-file-audio text-info' }"/> -->
        <sidebar-item
          :link="{
            name: menu_cdr,
            path: '/portal/record',
            icon: 'ni ni-chart-pie-35 text-info'
          }"
        />
        <sidebar-item
          :link="{
            name: menu_report,
            path: '/portal/report',
            icon: 'ni ni-chart-pie-35 text-info'
          }"
        />
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  computed: {
    menu_corporate: function() {
      return this.$t("menu.corporate");
    },

    menu_mlhg: function() {
      return this.$t("menu.mlhg");
    },
    menu_number: function() {
      return this.$t("menu.number");
    },
    menu_voicemail: function() {
      return this.$t("menu.voicemail");
    },
    menu_cdr: function() {
      return this.$t("menu.cdr");
    },
    menu_report: function() {
      return this.$t("menu.report");
    },
    menu_nseries: function() {
      return this.$t("menu.nseries");
    },
    menu_package: function() {
      return this.$t("menu.package");
    },
    menu_pilot_number: function() {
      return this.$t("menu.pilot_number");
    },
    menu_agent_number: function() {
      return this.$t("menu.agent_number");
    },
    menu_user: function() {
      return this.$t("menu.user");
    },

    ...mapGetters({
      isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isReadOnly: "Auth/isReadOnly",

      isCorporateSuperAdminMenu: "Auth/isCorporateSuperAdminMenu",
      isDtacAdminMenu: "Auth/isDtacAdminMenu",
      isCorporateAdminMenu: "Auth/isCorporateAdminMenu",
      isReadOnlyMenu: "Auth/isReadOnlyMenu",

      getUser: "Auth/getUser"
    })
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser"
    }),
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    }
  },
  mounted() {
    // this.user = localStorage.getItem('user')

    this.initScrollbar();
  }
};
</script>
<style lang="scss">
.text-dtac {
  color: #e7eaf2;
}
</style>
